import { Button, Card, EmptyState } from "@helmr/ui";
import { Link } from "react-router-dom";
import { strings } from "./strings";

export function NoAccess({ compact }: { compact?: boolean }) {
  return (
    <Card>
      <EmptyState compact={compact} icon="alert" title={strings.states.noAccessTitle} description={strings.states.noAccessBody} action={compact ? undefined : <Button as={Link} to="/home">{strings.states.backHome}</Button>} />
    </Card>
  );
}
